"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNames_1 = require("../../../../../utils/classNames");
const utils_1 = require("./utils");
exports.Input = (0, react_1.forwardRef)(({ className, crossOrigin, invalid = false, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("input", { ...props, ref: ref, className: (0, classNames_1.cn)('aries-input  focus:border-primary focus:ring-primary block w-full flex-row items-center justify-between space-x-2 border align-middle focus:outline-none focus:ring-1', invalid
            ? 'border-2 border-invalid text-invalid invalid:border-invalid invalid:text-invalid focus:invalid:border-invalid focus:invalid:ring-invalid'
            : '', className), autoComplete: props.autoComplete ?? 'off', onChange: (event) => {
            if (props.type === 'tel') {
                const { value } = event.target;
                event.target.value = (0, utils_1.normalizeTelNumber)(value);
            }
            if (props.onChange) {
                props.onChange(event);
            }
        }, pattern: (0, utils_1.getInputPattern)(props.type) }));
});
